import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=124e3caf&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124e3caf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124e3caf')) {
      api.createRecord('124e3caf', component.options)
    } else {
      api.reload('124e3caf', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=124e3caf&scoped=true&", function () {
      api.rerender('124e3caf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nBPJ0poyi4xR/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports